import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileSelection.css';
import Header from './Header';

const ProfileSelection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlUserId = urlParams.get('userId');
    const urlToken = urlParams.get('token');

    const storedUserId = localStorage.getItem('userId');
    const storedToken = localStorage.getItem('authToken');

    // If URL has token & userId → Save them to localStorage
    if (urlUserId && urlToken) {
      localStorage.setItem('userId', urlUserId);
      localStorage.setItem('authToken', urlToken);
    }



    const finalUserId = urlUserId || storedUserId;
    const finalToken = urlToken || storedToken;

    if (!finalToken || !finalUserId) {
      navigate('/login-User');
    }
  }, [navigate]);

  const handleClick = () => {
    const userId = new URLSearchParams(window.location.search).get('userId') || localStorage.getItem('userId');
    navigate(`/BrokerageProfile?userId=${userId}`);
  };

  const handleBrokerageClick = () => {
    const userId = new URLSearchParams(window.location.search).get('userId') || localStorage.getItem('userId');
    navigate(`/RealtorsProfile?userId=${userId}`);
  };

  return (
    <>
      <Header />
      <div className="selection-container">


        <div className="profile-card">
          <div className="icon-circle">
            <span className="profile-icon">🏢</span>
          </div>
          <h3>Realtors Profile</h3>
          <p>Ideal for real estate companies and brokerages managing multiple agents and extensive property portfolios.</p>
          <ul>
            <li>✅ Team management</li>
            <li>✅ Multiple agent profiles</li>
            <li>✅ Birthday wishes</li>
            <li>✅ Brand showcase</li>
          </ul>
          <button className="create-btn" onClick={handleBrokerageClick}>
            Create Realtors Profile
          </button>
        </div>
        <div className="profile-card">
          <div className="icon-circle">
            <span className="profile-icon">👤</span>
          </div>
          <h3>Brokerage Profile</h3>
          <p>Perfect for individual real estate agents and professionals who want to showcase their personal listings and achievements.</p>
          <ul>
            <li>✅ Personal listing management</li>
            <li>✅ Add a Team member</li>
            <li>✅ Suitable for individual goals</li>
            <li>✅ Direct contact info</li>
          </ul>
          <button className="create-btn" onClick={handleClick}>
            Create Brokerage Profile
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileSelection;